import { Component, Input } from '@angular/core'
import { RouterLink } from '@angular/router'
import { NgOptimizedImage } from '@angular/common'

@Component({
  selector: 'lg-logo-display',
  imports: [RouterLink, NgOptimizedImage],
  templateUrl: './logo-display.component.html',
  styleUrl: './logo-display.component.scss',
})
export class LogoDisplayComponent {
  @Input()
  logoUrl: string
  @Input()
  logoText: string
}
